import React from 'react';

interface SectionCardProps {
  variant?: 'default' | 'info' | 'support' | 'stats';
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const variantClasses: Record<string, string> = {
  default: 'bg-white rounded-3 border p-4 shadow-sm',
  info: 'bg-white rounded-3 border p-4 mb-4 shadow-sm',
  support: 'd-flex flex-column align-items-center text-center p-4',
  stats: 'text-center p-4',
};

export default function SectionCard({
  variant = 'default',
  title,
  subtitle,
  children,
  className = '',
  style,
}: SectionCardProps) {
  const baseClass = variantClasses[variant] || variantClasses.default;

  return (
    <div className={`${baseClass} ${className}`} style={style}>
      {title && (
        <h5 className="fw-bold mb-3" style={{ color: '#0B2545' }}>
          {title}
        </h5>
      )}
      {subtitle && (
        <small className="d-block text-muted text-uppercase fw-semibold mb-1" style={{ fontSize: '0.65rem' }}>
          {subtitle}
        </small>
      )}
      {children}
    </div>
  );
}
